import {API_BASE_URL} from './commonUrl'

export const UPLOAD_FILE = `${API_BASE_URL}/api/attachment/attachment/file?X-Authorization=` + localStorage.getItem('token')
export const DOWNLOAD_FILE = `${API_BASE_URL}/api/attachment/attachment/file-data/`



// WEBPACK FOOTER //
// ./src/common/utils/uploadFileUtil.js